"use strict";

/**
 * Accordion
 * @param  {obj}  Config object
 * @requires [util.js]
 */
SDG.accordion = function(opts) {
  var config = {
    cb: {
      open: null,
      // Callback on Open
      close: null, // Call back on Close
    },
    cls: {
      active: 'is-active',
      // Button active class
      open: 'is-open',
    },
    dom: {
      btn: 'js-acc-btn',
      // toggle trigger
      id: 'acc',
      // id of the accordion
      menu: 'js-acc-menu', // class to target the menu
    },
    enable_linking: false,
    open_option: null,
    // {number}
    responsive: false,
    // Use responsive?
    scroll: {
      use: false,
      // Use scroll
      scope: 'html,body',
      // Scroll scope
      offset_by: 60, // Integer
    },
    type: 'accordion',
    // 'accordin' or 'toggle'
    views: {
      active: null,
      // {array}
      inactive: null,
      // {array}
      current: null, // {string}
    },
  };

  var c = _.extend(config, opts); // Extend defaults with passed options

  var $accordion = document.getElementById(c.dom.id); // Object that all functions are bound to.

  var isSub;
  var windowWidth = window.outerWidth;
  /**
   * Init
   * @type {Function}
   */

  function init() {
    if (c.responsive) {
      responsive();

      _.windowResize(responsive);
    } else {
      bindEvents();
    } // check url

    if (c.enable_linking) {
      addHashChangeEvent();
      openMenuByUrl();
    } // open option

    if (c.open_option !== null) {
      openOption(c.open_option);
    }

    callbacks();
  }
  /**
   * add hash change event
   */

  function addHashChangeEvent() {
    window.addEventListener('hashchange', openMenuByUrl, false);
  }
  /**
   * bindEvents
   * @type {Function}
   * @param {el} Element to bind events to
   */

  function bindEvents() {
    if ($accordion) {
      _.addEvent({
        id: c.dom.id,
        className: c.dom.btn,
        event: 'click',
        fn: checkState,
      });

      window.addEventListener('resize', windowWidthResize);
    }
  }
  /**
   * unbindEvents
   * @type {Function}
   * @param {el} Element to bind events to
   */

  function unbindEvents() {
    _.removeEvent({
      id: c.dom.id,
      className: c.dom.btn,
      event: 'click',
      fn: checkState,
    });
  }
  /**
   * checkActive
   * @type {Function}
   */

  function checkState() {
    var isActive = _.hasClass(this, c.cls.active);

    var $menu = this.nextElementSibling;

    var $parentMenu = _.parents(this, '.' + c.dom.menu);

    if ($parentMenu) {
      isSub = true;
    } else {
      isSub = false;
    }

    if (isActive) {
      closeMenu($menu);

      _.removeClass(this, c.cls.active);
      this.setAttribute('aria-expanded', 'false');
    } else {
      openMenu($menu);

      _.addClass(this, c.cls.active);
      this.setAttribute('aria-expanded', 'true');
    }
  }
  /**
   * closeMenu
   * @type {Function}
   * @param {el} - Menu to close
   */

  function closeMenu(el) {
    var $parent = el.parentElement;
    var currentHeight = el.offsetHeight;
    var $activeBtns = $parent.querySelectorAll('.' + c.cls.active);
    var $activeBtn;
    var $activeMenu;
    el.style.height = currentHeight + 'px';

    _.slideUp(el);

    if ($activeBtns.length > 0) {
      Object.keys($activeBtns).forEach(function(key) {
        $activeBtn = $activeBtns[key];
        $activeMenu = $activeBtn.nextElementSibling;

        _.removeClass($activeBtn, c.cls.active);

        _.removeClass($activeMenu, c.cls.open);

        _.slideUp($activeMenu);
      });
    }

    _.trigger($accordion, 'closeCb');
  }
  /**
   * openMenu
   * @param {el} - Menu to open
   */

  function openMenu(el) {
    var $activeBtn;
    var $activeBtns;
    var $activeMenu;
    var $parentMenu;

    if (c.type === 'accordion') {
      if (isSub) {
        $parentMenu = _.parents(el, '.' + c.cls.open);
        Object.keys($parentMenu).forEach(function(key) {
          if ($parentMenu[key] && $parentMenu[key] !== el) {
            $parentMenu = $parentMenu[key];
          }
        });
        $activeBtns = $parentMenu.querySelectorAll(
          '.' + c.dom.btn + '.' + c.cls.active
        );
      } else {
        $activeBtns = $accordion.querySelectorAll('.' + c.cls.active);
      }

      if ($activeBtns.length > 0) {
        Object.keys($activeBtns).forEach(function(key) {
          $activeBtn = $activeBtns[key];
          $activeMenu = $activeBtn.nextElementSibling;
          closeMenu($activeMenu);

          _.removeClass($activeBtn, c.cls.active);

          _.removeClass($activeMenu, c.cls.open);
        });
      }
    }

    _.slideDown(el);

    _.addClass(el, c.cls.open);

    if (isSub) {
      $parentMenu = _.parents(el, '.' + c.cls.open);
      Object.keys($parentMenu).forEach(function(key) {
        if ($parentMenu[key] && $parentMenu[key] !== el) {
          $parentMenu = $parentMenu[key];
          $parentMenu.style.height = '';
        }
      });
    }

    _.trigger($accordion, 'openCb');
  }
  /**
   * closeAllMenus
   * @type {Function}
   */

  function closeAllMenus() {
    var $activeTriggers = $accordion.querySelectorAll(
      '.' + c.dom.btn + '.' + c.cls.active
    );
    var $trigger;
    var $menu;
    var i;

    if ($activeTriggers.length > 0) {
      for (i = 0; i < $activeTriggers.length; i += 1) {
        $trigger = $activeTriggers[i];
        $menu = $trigger.nextElementSibling;

        _.removeClass($trigger, c.cls.active);

        closeMenu($menu);
      }
    }
  }
  /**
   * window Width Resize
   */

  function windowWidthResize(e) {
    var currentWidth = window.outerWidth;

    if (currentWidth !== windowWidth) {
      resetActive(e);
      windowWidth = currentWidth;
    }
  }
  /**
   * responsive
   * @type {Function}
   */

  function responsive() {
    var activeViews = c.views.active;
    var inactiveViews = c.views.inactive;
    var view;
    var i;

    for (i = 0; i < activeViews.length; i += 1) {
      view = activeViews[i];

      if (c.views.current !== view) {
        _.mq({
          view: view,
          callback: activeCb,
        });
      }
    }

    for (i = 0; i < inactiveViews.length; i += 1) {
      view = inactiveViews[i];

      if (c.views.current !== view) {
        _.mq({
          view: view,
          callback: inactiveCb,
        });
      }
    }
  }
  /**
   * active callback
   * @return {Function}
   */

  function activeCb() {
    var view = this.view;
    c.views.current = view;
    bindEvents();
  }
  /**
   * inactive callback
   * @return {Function}
   */

  function inactiveCb() {
    var view = this.view;
    c.views.current = view;
    unbindEvents();
    resetActive(true);
  }
  /**
   * active callback
   * @return {Function}
   */

  function resetActive(fullReset) {
    var $activeTriggers; // const $activeTriggers = $accordion.querySelectorAll('.' + c.dom.btn +'.' + c.cls.active);

    var $trigger;
    var $menu;
    var i;
    var height;

    if (fullReset) {
      $activeTriggers = $accordion.querySelectorAll('.' + c.dom.btn);
    } else {
      $activeTriggers = $accordion.querySelectorAll(
        '.' + c.dom.btn + '.' + c.cls.active
      );
    }

    if ($activeTriggers.length > 0) {
      for (i = 0; i < $activeTriggers.length; i += 1) {
        $trigger = $activeTriggers[i];
        $menu = $trigger.nextElementSibling;

        if (fullReset) {
          _.removeClass($trigger, c.cls.active);

          _.removeClass($menu, c.cls.open);

          $menu.style.display = '';
          $menu.style.height = '';
          $menu.style.paddingTop = '';
          $menu.style.paddingBottom = '';
        } else {
          height = _.getHiddenStyles($menu).elHeight;
          $menu.style.height = height + 'px';
        }
      }
    }
  }
  /**
   * open menu by url
   */

  function openMenuByUrl() {
    var hash = window.location.hash;
    var elIsButton;
    var $btn;
    var $menu; // if hash doesn't exist, exit function

    if (!hash) return; // set el from hash

    var id = hash.replace('#', '');
    var $el = document.getElementById(id); // if element exists, continue, else warn user

    if ($el) {
      elIsButton = _.hasClass($el, c.dom.btn);
      $btn = elIsButton ? $el : $el.querySelector('.' + c.dom.btn);
      $menu = $btn.nextElementSibling; // open menu

      if ($menu) {
        openMenu($menu);

        _.addClass($btn, c.cls.active);
      }
    } else {
      console.warn('Hash element ' + id + " doesn't exist.");
    }
  }
  /**
   * open option
   * @param {number} option
   */

  function openOption(option) {
    var $activeTriggers = $accordion.querySelectorAll('.' + c.dom.btn);
    var $trigger;
    var $menu;

    if ($activeTriggers.length) {
      $trigger = $activeTriggers[option];
      $menu = $trigger.nextElementSibling;
      openMenu($menu);

      _.addClass($menu, c.cls.open);

      _.addClass($trigger, c.cls.active);
    }
  }
  /**
   * callbacks
   */

  function callbacks() {
    _.addEvent({
      id: $accordion,
      event: 'openCb',
      fn: function fn() {
        if (typeof c.cb.open === 'function') {
          c.cb.open();
        }

        return undefined;
      },
    });

    _.addEvent({
      id: $accordion,
      event: 'closeCb',
      fn: function fn() {
        if (typeof c.cb.close === 'function') {
          c.cb.close();
        }

        return undefined;
      },
    });
  }
  /**
   * return
   * @type {Object}
   */

  return {
    init: init,
    closeAll: closeAllMenus,
    closeMenu: closeMenu,
    unbindEvents: unbindEvents,
  };
};
